import { Component } from '@theme/component';

/**
 * @typedef {object} CollectionIntroRefs
 * @property {HTMLElement} preview
 * @property {HTMLElement} content
 * @property {HTMLButtonElement} toggle
 * @extends {Component<CollectionIntroRefs>}
 */
class CollectionIntro extends Component {
  requiredRefs = ['preview', 'content', 'toggle'];

  connectedCallback() {
    super.connectedCallback();
    this.#render(false);
  }

  updatedCallback() {
    super.updatedCallback();
    this.#render(this.refs.toggle.getAttribute('aria-expanded') === 'true');
  }

  toggle() {
    const expanded = this.refs.toggle.getAttribute('aria-expanded') !== 'true';
    this.#render(expanded);
    if (!expanded && this.refs.toggle.getBoundingClientRect().top < 0) {
      this.refs.toggle.scrollIntoView({ block: 'center', behavior: 'instant' });
    }
  }

  #render(expanded) {
    this.refs.preview.hidden = expanded;
    this.refs.content.hidden = !expanded;
    this.refs.toggle.hidden = false;
    this.refs.toggle.setAttribute('aria-expanded', String(expanded));
    this.refs.toggle.querySelector('[data-show-more]').hidden = expanded;
    this.refs.toggle.querySelector('[data-show-less]').hidden = !expanded;
  }
}

if (!customElements.get('collection-intro-component')) {
  customElements.define('collection-intro-component', CollectionIntro);
}
